import React, { ChangeEvent, useState } from 'react';
import ReferralEmail from './ReferralEmail';
import ReferralText from './ReferralText';
import { Grid } from '@material-ui/core';
import { PastProvider } from './models';
import { Colors, OutlinedDropdown, Text } from 'library';
import ReferralCopyInput from './ReferralCopyInput';
import ReferralLink from './ReferralLink';
import ReferralFacebook from './ReferralFacebook';

const emailMethod = { key: 'email', value: 'Email' };
const textMethod = { key: 'text', value: 'Text message' };
const facebookMethod = { key: 'facebook', value: 'Facebook' };
const defaultMethod = { key: 'link', value: 'Link' };

const allMethods = [defaultMethod, emailMethod, textMethod, facebookMethod];

interface Props {
    message: string;
    referredProvider: PastProvider;
    setMessage: (item: string) => void;
    url: string;
    referralContext: string;
    availableMethods?: string[];
    promo?: string;
    setPromoStep?: (x: string) => void;
}
const ReferralMethodChoice = ({
    message,
    referredProvider,
    setMessage,
    url,
    referralContext,
    availableMethods,
    promo,
    setPromoStep,
}: Props) => {
    const [method, setMethod] = useState(!!availableMethods ? availableMethods[0] : defaultMethod.key);

    const onChangeMethod = (e: ChangeEvent<{ name?: string; value: string }>) => {
        setMethod(e.target.value);
    };

    const options = !!availableMethods ? allMethods.filter((x) => availableMethods.includes(x.key)) : allMethods;

    function getInputComponent() {
        if (method === 'text' || method === 'email') {
            return <ReferralCopyInput message={message} setMessage={setMessage} />;
        }
    }

    function getMethodComponent() {
        if (method === 'link') {
            return (
                <ReferralLink
                    message={message}
                    link={url}
                    title={''}
                    referralContext={`${referralContext}: Referral Link`}
                />
            );
        }
        if (method === 'email') {
            return (
                <ReferralEmail
                    referredProvider={referredProvider}
                    message={message}
                    referralContext={`${referralContext}: Share via Email`}
                    promo={promo}
                    setPromoStep={setPromoStep}
                />
            );
        }
        if (method === 'text') {
            return (
                <ReferralText
                    referredProvider={referredProvider}
                    message={message}
                    referralContext={`${referralContext}: Share via Text`}
                    promo={promo}
                    setPromoStep={setPromoStep}
                />
            );
        }
        if (method === 'facebook') {
            return (
                <ReferralFacebook
                    referredProvider={referredProvider}
                    link={url}
                    referralContext={`${referralContext}: Share via Facebook`}
                />
            );
        }
    }

    return (
        <Grid container direction="column">
            <Grid container direction="row" alignItems="center">
                <Text variant="h2" color={Colors.turquoise} textStyle={{ marginRight: 10 }}>
                    Share via:
                </Text>
                <OutlinedDropdown fields={options} value={method} onChange={onChangeMethod} />
            </Grid>
            {getInputComponent()}
            {getMethodComponent()}
        </Grid>
    );
};

export default ReferralMethodChoice;
